module.exports = __webpack_public_path__ + "media/landing_page/hero-mobile-2-45fe4ce1.webp";